// @ts-nocheck
import {z} from "zod";

export const MIN_PAYKU_WITHDRAWAL = 1000;

const rutPattern = /^\d{7,8}[0-9kK]$/;

export const buildPaykuWithdrawalSchema = (availableBalance, t) =>
  z.object({
    amount: z.coerce
      .number({message: t("withdrawalPaykuMinAmount")})
      .min(MIN_PAYKU_WITHDRAWAL, t("withdrawalPaykuMinAmount"))
      .max(availableBalance, t("withdrawalPaykuInsufficientBalance")),
    beneficiaryName: z.string().trim().min(1, t("withdrawalPaykuBeneficiaryNameRequired")),
    email: z
      .string()
      .trim()
      .min(1, t("withdrawalPaykuValidEmail"))
      .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, t("withdrawalPaykuValidEmail")),
    phone: z.string().trim().min(1, t("withdrawalPaykuPhoneRequired")),
    accountbank_name: z.string(),
    accountbank_rut: z
      .string()
      .transform(v => v.replace(/[^0-9kK]/g, ""))
      .refine(v => rutPattern.test(v), t("withdrawalPaykuValidRUT")),
    accountbank_sbif: z.string().trim().min(1, t("withdrawalPaykuBankRequired")),
    accountbank_type: z.number(),
    accountbank_num: z.string().trim().min(1, t("withdrawalPaykuAccountNumberRequired")),
  });
